import { useState } from 'react';
import { Container, HeaderPages } from '../components';
import { ProjectCardList, FilterProjectList } from '../components';
import styled from 'styled-components';
import '../animation/boundInUp.css';

const Portfolio = () => {
  const [active, setActive] = useState('All');
  return (
    <Container>
      <Container_Portfolio>
        <HeaderPages title="My Portfolio" shadow={'My'} />
        <FilterProjectList setCatActive={setActive} catActive={active} />
        <ProjectCardList catActive={active} />
      </Container_Portfolio>
    </Container>
  );
};

export default Portfolio;

// needed refactor
export const Container_Portfolio = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 12rem;
  align-items: center;
  width: 100%;
  height: 100%;
`;
